import styled from "styled-components";

export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 32px;
  height: 32px;
`;
